export default __webpack_public_path__ + "8510454354521c3b6c45692b1f8ea638.svg";